<script>
import axios from "axios";
import Swal from "sweetalert2";
import {ref} from "vue";

export default {
  name: 'econtacts',
  props:['eContactlist'],
  emits: ["onFire", "eContactData"],
  setup(props, { emit }) {
    const notify = ref("cacas");
    const notifyNotes = () => {
      emit('onFire', notify);
    };
    return { notify, notifyNotes };
  },
  data() {
    return {
      notes: [],
      errors: [],
      editing: false,
      editID: null,
      formFields: [
        'benFirstName1', 'benLastName1', 'benAddress1',
        'benPhone1', 'benState1', 'benPostalCode1',
        'benRelation1', 'benAge1'
      ],
    };
  },
  methods: {
    validPhone(phone) {
      const regex = /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm;
      return regex.test(phone);
    },
    async fillForm(data) {
      this.editing = true;
      this.editID = data.ID;
      document.getElementById('benFirstName1').value = data.firstName;
      document.getElementById('benLastName1').value = data.lastName;
      document.getElementById('benAddress1').value = data.address;
      document.getElementById('benPhone1').value = data.phone;
      document.getElementById('benState1').value = data.state;
      document.getElementById('benPostalCode1').value = data.postalCode;
      document.getElementById('benRelation1').value = data.relationship;
      document.getElementById('benAge1').value = data.age;
    },
    clearForm() {
      this.editing = false;
      this.editID = null;
      const fields = ['FirstName1', 'LastName1', 'Address1', 'Phone1', 'State1', 'PostalCode1', 'Relation1', 'Age1'];
      fields.forEach(id => document.getElementById(`ben${id}`).value = '');
    },
    async createContact() {
      this.errors = [];

      const getValue = id => document.getElementById(id).value.trim();
      const requiredFields = [
        { id: 'benFirstName1', label: 'First Name' },
        { id: 'benLastName1', label: 'Last Name' },
        { id: 'benPhone1', label: 'Phone' },
        { id: 'benRelation1', label: 'Relationship' },
      ];

      requiredFields.forEach(field => {
        const val = getValue(field.id);
        if (val === '' || val.length <= 2) {
          this.errors.push(`${field.label} is required.`);
        }
        if (field.label === 'Phone' && !this.validPhone(val)) {
          this.errors.push('Please enter a valid phone number.');
        }
      });

      if (this.errors.length) {
        await Swal.fire({
          title: 'Please fix the following:',
          html: this.errors.map(e => `<b>${e}</b>`).join('<br>'),
          icon: 'warning',
          showCloseButton: true
        });
        return;
      }

      const payload = {
        firstName: getValue('benFirstName1'),
        lastName: getValue('benLastName1'),
        address: getValue('benAddress1'),
        phone: getValue('benPhone1'),
        phoneNumber: getValue('benPhone1'),
        state: getValue('benState1'),
        postalCode: getValue('benPostalCode1'),
        relation: getValue('benRelation1'),
        relationship: getValue('benRelation1'),
        age: getValue('benAge1'),
        clientsInfo: JSON.parse(localStorage.getItem("clientFormData")),
        token: localStorage.getItem('jwt'),
        userID: localStorage.getItem('id'),
        clientID: this.editID,
        selectedUser: localStorage.getItem('selectedUser'),
        userEmail: localStorage.getItem('email'),
        createdBy: localStorage.getItem('email'),
      };

      const url = this.editing
          ? `/api/client/updateeContact`
          : '/api/client/createecontacts';

      try {
        let response = []

        if (url.includes('updateeContact')) {
           response = await axios.put(url, payload);  // si estás editando
        } else {
           response = await axios.post(url, payload); // si estás creando
        }

        this.$emit('eContactData', response);
        await Swal.fire({
          icon: 'success',
          title: 'Success',
          text: this.editing ? 'eContact updated!' : 'eContact created!'
        });
        this.clearForm();
      } catch (error) {
        let list = '';
        if (error.response && error.response.data) {
          for (const property in error.response.data) {
            this.errors.push(`${property}: ${error.response.data[property]}`);
            list += '<b>' + error.response.data[property] + '</b><br>';
          }
        } else {
          this.errors.push('Unknown error, contact SysAdmin.');
        }

        await Swal.fire({
          title: "Error",
          html: list,
          icon: 'error',
          showCloseButton: true
        });
      }
    },
    anyFieldHasValue() {
      return this.formFields.some(id => document.getElementById(id)?.value.trim() !== '');
    },
    async handleConfirm() {
      const mode = this.editing ? 'You\'re Editing an E. Contact' : 'You\'re Creating a new E. Contacto';
      const result = await Swal.fire({
        title: '¿Would you like to continue?',
        text: `${mode}. ¿Do you Comfirm?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Continue',
        cancelButtonText: 'Cancell'
      });

      if (result.isConfirmed) {
        this.createContact();
      }
    }

  },
};
</script>

<template>
  <div class="card">
    <div class="card-header">
      <h5 class="card-title mb-0">Emergency Contacts</h5>
    </div>
    <div class="card-body">
      <div class="mb-4">
        <div style="overflow-y: scroll; max-height: 20vh; overflow-x: hidden;" id="eContactList">
          <div v-for="data in eContactlist" :key="data.ID">
            <div class="row">
              <div class="col-lg-6">
                <label for="benFirstName" class="form-label"><b>First Name</b></label>
                <div class="d-flex align-items-center justify-content-between">
                  <p class="mb-0">{{ data.firstName }}</p>
                  <button type="button" class="btn btn-sm btn-outline-primary ms-2" @click="fillForm(data)">Edit</button>
                </div>
              </div>
              <div class="col-lg-6">
                <label for="benLastName" class="form-label"><b>Last Name</b></label>
                <p>{{ data.lastName }}</p>
              </div>
              <div class="col-lg-6">
                <label for="benAddress" class="form-label"><b>Address</b></label>
                <p>{{ data.address }}</p>
              </div>
              <div class="col-lg-6">
                <label for="benPhone" class="form-label"><b>Phone</b></label>
                <p>{{ data.phone }}</p>
              </div>
              <div class="col-lg-6">
                <label for="benState" class="form-label"><b>State</b></label>
                <p>{{ data.state }}</p>
              </div>
              <div class="col-lg-6">
                <label for="benPostalCode" class="form-label"><b>Postal Code</b></label>
                <p>{{ data.postalCode }}</p>
              </div>
              <div class="col-lg-6">
                <label for="benRelation" class="form-label"><b>Relationship</b></label>
                <p>{{ data.relationship }}</p>
              </div>
              <div class="col-lg-6">
                <label for="benAge" class="form-label"><b>Age</b></label>
                <p>{{ data.age }}</p>
              </div>
              <div class="col-md-6" style="display: flex; justify-content: flex-end;">
              </div>
              <div class="col-md-6" style="display: flex; justify-content: flex-end;">
              </div>
              <hr>
            </div>
          </div>
        </div>
        <div style="overflow-y: scroll; max-height: 37vh; overflow-x: hidden;">
          <div class="row">
            <div class="alert" :class="editing ? 'alert-warning' : 'alert-success'" role="alert">
              {{ editing ? '🟡 Edit a E. Contact' : '🟢 Creat a new E. Contact.' }}
            </div>
            <div class="col-lg-6">
              <label for="benFirstName" class="form-label">First Name</label>
              <input type="text" id="benFirstName1" class="form-control mb-2" placeholder="Enter First Name" required value="" style="padding: 0.2rem 0.9rem;">
            </div>
            <div class="col-lg-6">
              <label for="benLastName" class="form-label">Last Name</label>
              <input type="text" id="benLastName1" class="form-control mb-2" placeholder="Enter Last Name" required value="" style="padding: 0.2rem 0.9rem;">
            </div>
            <div class="col-lg-6">
              <label for="benAddress" class="form-label">Address</label>
              <input type="text" id="benAddress1" class="form-control mb-2" placeholder="Enter Address" required value="" style="padding: 0.2rem 0.9rem;">
            </div>
            <div class="col-lg-6">
              <label for="benPhone" class="form-label">Phone</label>
              <input type="text" id="benPhone1" class="form-control mb-2" placeholder="Enter Phone" required value="" style="padding: 0.2rem 0.9rem;">
            </div>
            <div class="col-lg-6">
              <label for="benState" class="form-label">State</label>
              <input type="text" id="benState1" class="form-control mb-2" placeholder="Enter State"  required value="" style="padding: 0.2rem 0.9rem;">
            </div>
            <div class="col-lg-6">
              <label for="benPostalCode" class="form-label">Postal Code</label>
              <input type="text" id="benPostalCode1" class="form-control mb-2" placeholder="Enter Postal Code" required value="" style="padding: 0.2rem 0.9rem;">
            </div>
            <div class="col-lg-6">
              <label for="benRelation" class="form-label">Relationship</label>
              <input type="text" id="benRelation1" class="form-control mb-2" placeholder="Enter Relationship" required value="" style="padding: 0.2rem 0.9rem;">
            </div>
            <div class="col-lg-6">
              <label for="benAge" class="form-label">Age</label>
              <input type="text" id="benAge1" class="form-control mb-2" placeholder="Enter Age" required style="padding: 0.2rem 0.9rem;">
            </div>
            <div class="col-md-6" style="display: flex; justify-content: flex-end;">
            </div>
            <div class="col-md-6" style="display: flex; justify-content: flex-end;">
              <div class="d-flex justify-content-end gap-2 align-items-center">
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="clearForm"
                    v-if="editing || anyFieldHasValue()"
                >
                  Clear
                </button>

                <button
                    type="button"
                    class="btn btn-success"
                    @click="handleConfirm"
                >
                  {{ editing ? 'Update' : 'Save' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- end card -->
</template>